import { cn } from "ics-ui-kit/lib/utils";
import type { PropsWithChildren } from "react";

type FadeRevealProps = PropsWithChildren<{
	className?: string;
	isVisible?: boolean;
	revealOnGroupInteraction?: boolean;
}>;

export const FadeReveal = ({
	children,
	className,
	isVisible = false,
	revealOnGroupInteraction = false,
}: FadeRevealProps) => (
	<span
		className={cn(
			"pointer-events-none opacity-0 transition-opacity duration-100 ease-out motion-reduce:transition-none",
			revealOnGroupInteraction &&
				"group-hover:pointer-events-auto group-hover:opacity-100 group-focus-within:pointer-events-auto group-focus-within:opacity-100",
			isVisible && "pointer-events-auto opacity-100",
			className,
		)}
		data-state={isVisible ? "visible" : "hidden"}
	>
		{children}
	</span>
);
